import React, { useState, useCallback, useEffect, useContext } from 'react';
import {
  Button,
  Dialog,
  Typography,
  DialogTitle,
  DialogActions,
  CircularProgress,
} from '@material-ui/core';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router';
import { GlobalsContext } from '../../../store/Globals';
import { getISODateTimeString } from '../../../utils/dateUtils';

import { instance } from '../../../services/api';

import { DialogContent } from './styles';

type IListTypeModal = React.FC<{
  listData: any[];
  propType: string;
  open: boolean;
  tag: string;
  setOpen(open: boolean): void;
}>;

const ListTypeModal: IListTypeModal = ({
  open,
  listData,
  propType,
  tag,
  setOpen,
}) => {
  const globals = useContext(GlobalsContext);
  const history = useHistory();
  const [isAsset, setIsAsset] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message] = useState<string | JSX.Element>('There is no elements');
  const [data, setData] = useState<any[]>([]);

  const getAssetButton = useCallback(
    (assetTag: string, assetKey: string) => {
      return new Promise((resolve, reject) => {
        instance
          .post(`/api/query/readAsset`, {
            key: { '@assetType': assetTag, '@key': assetKey },
            resolve: true,
          })
          .then((response) => {
            resolve(
              <div key={assetKey} style={{ margin: '10px 0' }}>
                <Button
                  onClick={() => {
                    history.push(`/show/${assetKey}`);
                  }}
                  disabled={!assetKey}
                  variant="outlined"
                >
                  {globals.itemLabel(response.data, true)}
                </Button>
              </div>,
            );
          })
          .catch(() => {
            reject(toast.error('API asset read request fail'));
          });
      });
    },
    [globals, history],
  );

  useEffect(() => {
    setLoading(true);

    if (propType.indexOf('->') >= 0) {
      setData([]);
      setIsAsset(true);

      if (listData) {
        Promise.all(
          listData.map((item) =>
            getAssetButton(item['@assetType'], item['@key']),
          ),
        ).then((result) => {
          setData((state) => [...state, result]);
          setLoading(false);
        });
      } else {
        setLoading(false);
      }
    } else {
      setData(listData);
      setLoading(false);
    }
  }, [listData, getAssetButton, propType]);

  const capitalize = (string: string) =>
    string.charAt(0).toUpperCase() + string.slice(1);

  const getItemText = (item: string, idx: number) => {
    const getText = () => {
      const text = `${item}`;

      switch (propType) {
        case 'string':
          return capitalize(item);
        case 'boolean':
          return text.toUpperCase();
        case 'datetime':
          return getISODateTimeString(item);
        default:
          return text;
      }
    };

    return (
      <Typography component="span">
        <b>{`${idx}: `}</b>&nbsp;&nbsp;
        {getText()}
      </Typography>
    );
  };

  return (
    <div>
      <Dialog
        open={open}
        onBackdropClick={() => {
          setOpen(false);
        }}
      >
        <DialogTitle>{capitalize(tag)}</DialogTitle>

        <DialogContent>
          {loading ? (
            <CircularProgress style={{ margin: '0 auto' }} />
          ) : !data || (data && data.length <= 0) ? (
            message
          ) : (
            data.map((item, index) => (
              <div key={`item${index}`}>
                {!isAsset ? (
                  <Typography style={{ margin: '10px' }}>
                    {propType === 'url' ? (
                      <a href={item} target="_blank" rel="noopener noreferrer">
                        {getItemText(item, index + 1)}
                      </a>
                    ) : (
                      <>{getItemText(item, index + 1)}</>
                    )}
                  </Typography>
                ) : (
                  <div key={`item${index}`} style={{ margin: '10px' }}>
                    {item}
                  </div>
                )}
              </div>
            ))
          )}
        </DialogContent>

        <DialogActions>
          <Button
            color="primary"
            onClick={() => {
              setOpen(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ListTypeModal;
